import React, { ReactElement } from "react";
import shortid from "shortid";
import { info03, info03Cause, info03Cure, info03Symptom } from "../configs";

const Info03 = (): ReactElement => {
  return (
    <div className="skin-contents__inner">
      <div className="skin-contents__image--info">
        <h2 className="title">백반증이란?</h2>

        {/** top */}
        <div className="skin-contents__image--top">
          {info03.map((item) => (
            <div
              className="image-contents title-contents"
              key={shortid.generate()}
            >
              <div className="title-contents__icon">
                <i className={`icon ${item.className}`} />
              </div>
              <strong className="info">{item.title}</strong>
              {item.info.split("\n").map((text) => (
                <p className="sub-info" key={shortid.generate()}>
                  {text}
                </p>
              ))}
            </div>
          ))}
        </div>

        {/** cause */}
        <div className="skin-contents__image--cause">
          <h2 className="title">원인</h2>
          <div className="cause-inner">
            {info03Cause.map((item) => (
              <div
                className="image-contents cause-contents"
                key={shortid.generate()}
              >
                <div className="cause-contents__icon">
                  <i className={`icon ${item.className}`} />
                </div>
                <strong className="info">{item.title}</strong>
                {item.info.split("\n").map((text) => (
                  <p className="sub-info" key={shortid.generate()}>
                    {text}
                  </p>
                ))}
              </div>
            ))}
          </div>
        </div>

        {/** symptom */}
        <div className="skin-contents__image--symptom">
          <h2 className="title">증상</h2>
          <div className="image-text__inner">
            {info03Symptom.map((item) => (
              <div className="image-text" key={shortid.generate()}>
                <p className="sub-info">{item.info}</p>
              </div>
            ))}
          </div>
        </div>

        {/** cure */}
        <div className="skin-contents__image--cure">
          <h2 className="title">진단과 치료</h2>
          <div className="cure-bg" />
          <div className="image-text__inner">
            {info03Cure.map((item) => (
              <div className="image-text" key={shortid.generate()}>
                <strong className="info">{item.title}</strong>
                <p className="sub-info">{item.info}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Info03;
